import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import * as actions from './ana-biz-application-list.actions';
import { AnaBizApplicationListState } from './ana-biz-application-list.state';

/**
 * anaBizApplicationList initial state
 */
export const anaBizApplicationListInitialState: AnaBizApplicationListState = {
  model: null,
};

/**
 * List of basic actions for AnaBizApplicationList Store
 */
export const anaBizApplicationListReducerFeatures: ReducerTypes<AnaBizApplicationListState, ActionCreator[]>[] = [
  on(actions.setAnaBizApplicationList, (_state, payload) => ({ ...payload })),

  on(actions.updateAnaBizApplicationList, (state, payload) => ({ ...state, ...payload })),

  on(actions.resetAnaBizApplicationList, () => anaBizApplicationListInitialState),
];

/**
 * AnaBizApplicationList Store reducer
 */
export const anaBizApplicationListReducer = createReducer(
  anaBizApplicationListInitialState,
  ...anaBizApplicationListReducerFeatures
);
